import { type FC } from "react";
import { useWorkspaceDocumentVersionStore } from "@/stores/workspace-document-version.store";
import VersionComponentItem from "./version-history-components/VersionComponentItem";

const VersionHistoryTab: FC = () => {
  const { workspaceDocument, selectedVersion } =
    useWorkspaceDocumentVersionStore();

  const sortedRevisions =
    workspaceDocument?.revisions?.sort(
      (a, b) => b.revisionVersion - a.revisionVersion
    ) || [];

  return (
    <div className="flex flex-col h-full">
      <div className="mb-2 px-2">
        <h3 className="text-lg font-medium">Versionshistorik</h3>
        {selectedVersion && (
          <p className="text-sm text-muted-foreground">
            Version {selectedVersion.revisionVersion} er valgt
          </p>
        )}
      </div>
      <div className="flex flex-col gap-3 px-2 py-2 overflow-y-auto">
        {sortedRevisions.length > 0 ? (
          sortedRevisions.map((revision) => (
            <VersionComponentItem key={revision.blobId} revision={revision} />
          ))
        ) : (
          <div className="text-center text-muted-foreground py-8">
            Ingen versioner tilgængelige
          </div>
        )}
      </div>
    </div>
  );
};

export default VersionHistoryTab;
